import { Geopoint } from 'pleinchamp-api-client';
import { IconSizes } from '@components/icons/icon.types';
import { WeatherCodeIcon } from '@components/icons/meteo/WeatherCode';
import { PlcAnchor } from '@layout/components/PlcAnchor/PlcAnchor.component';
import { computeMeteoInfoFromDateAndPostion, isItNight } from '@meteo/business/meteo.utils';
import { WeatherCode } from '@meteo/types';
import classnames from 'classnames';
import { Dayjs } from 'dayjs';
import { getHourByHourRedirection } from './Header.utils';

interface Props {
  code?: WeatherCode;
  onMouseOver: () => void;
  date: Dayjs;
  isEmphasis: boolean;
  isLoading?: boolean;
  coordinates: Geopoint;
  locality: string;
  forceDay: boolean;
}

function WeatherCodeHeader({
  locality,
  code,
  forceDay,
  onMouseOver,
  date,
  isEmphasis,
  isLoading = false,
  coordinates,
}: Props) {
  const { latitude, longitude } = coordinates;
  const { sunrise, sunset } = computeMeteoInfoFromDateAndPostion(date.toDate(), latitude, longitude);

  return (
    <th className={classnames({ emphasis: isEmphasis })} onMouseEnter={onMouseOver}>
      {code === undefined || code === null ? null : (
        <PlcAnchor linkProps={getHourByHourRedirection(locality, date)}>
          <WeatherCodeIcon
            height={44}
            isLoading={isLoading}
            night={!forceDay && isItNight(sunrise, sunset, date)}
            variant={IconSizes.tiny}
            weatherCode={code as number}
            width={44}
          />
        </PlcAnchor>
      )}
    </th>
  );
}

export { WeatherCodeHeader };
